import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { AntdRadioButton, Filters, RadioOptions } from "./styles";
import { Radio } from "antd";
import Main from "../../../../layout/main/Main";
import { COLORS, Typo } from "../../../../layout/theme";
import DataTable from "../../../../common/data-table/DataTable";
import {
	get_laboratory_suggestion_header_info,
	get_laboratory_suggestions_page,
} from "../../../../../api/endpoints/laboratorySuggestions";

export default function LaboratoryList({ clientId }) {
	const [searchParams] = useSearchParams();
	const uri = searchParams.get("uri");
	const [data, setData] = useState(null);
	const [state, setState] = useState("ACTIVE");
	const [headerInfo, setHeaderInfo] = useState(null);
	const [key, setKey] = useState("null");

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const columns = [
		{
			title: () => <div style={{ color: COLORS.White }}>Laboratorio</div>,
			dataIndex: "laboratoryName",
			render: (value, record) => (
				<Link
					to={`/admin/suggestedProducts/${key.id}?uri=${uri}`}
					onMouseOver={() => setKey(record)}
				>
					<Typo type="secondary" fontWeight={600} fontSize={14}>
						{value}
					</Typo>
				</Link>
			),
		},
	];

	const fetch_data_laboratory_suggestions = async (page, search) => {
		const res = await get_laboratory_suggestions_page(search, state, page);
		setData(res);
	};

	useEffect(() => {
		fetch_data_laboratory_suggestions(1, clientId);
	}, [state]);

	const fetch_laboratory_suggestions_header = async (search) => {
		const res = await get_laboratory_suggestion_header_info(search);
		setHeaderInfo(res);
	};

	useEffect(() => {
		fetch_laboratory_suggestions_header(clientId);
	}, [state]);

	return (
		<Main>
			<Main.Breadcrumb>
				<Main.BreadcrumbItem>
					{uri ? (
						<Link to={"/" + uri}>Configuración General</Link>
					) : (
						<Link to="/">Home</Link>
					)}
				</Main.BreadcrumbItem>
				<Main.BreadcrumbSeparator />
				<Main.ActiveBreadcrumbItem>
					Listado de laboratorios
				</Main.ActiveBreadcrumbItem>
			</Main.Breadcrumb>

			<Main.Body>
				<RadioOptions>
					<Radio.Group value={state} onChange={(e) => setState(e.target.value)}>
						<AntdRadioButton value="ACTIVE">
							Activo ({headerInfo?.totalActive})
						</AntdRadioButton>
						<AntdRadioButton value="DELETED">
							Inactivo ({headerInfo?.totalDisabled})
						</AntdRadioButton>
					</Radio.Group>
				</RadioOptions>
				<DataTable
					data={data}
					fetch={fetch_data_laboratory_suggestions}
					columns={columns}
				/>
			</Main.Body>
		</Main>
	);
}
